import React, {useState, useEffect, Fragment} from 'react'
import {Menu} from 'semantic-ui-react'
import {SortableItem} from './sortable_item';
import {SortableContainer} from 'react-sortable-hoc';

export const SortableList = SortableContainer(({items, mode, path, edit, editMarkets, open, release, ungroup}) => {
  return (
    <Menu fluid vertical>
    	<Menu.Item style={{backgroundColor: '#CCCCCC'}}>
    		
    	</Menu.Item>

      {
      (typeof items !== 'undefined' && items !== null)?
        items.map((item, index) => (
            <SortableItem collection={
                        (typeof item._partOf !== 'undefined' && item._partOf !== null)?
                            item._partOf
                        :'__root__'
                    } key={`item-${index}`} ungroup={ungroup} edit={edit} editMarkets={editMarkets} mode={mode} open={open} index={index} isFirst={index === 0} isLast={index+1 === items.length} release={release} item={item} />
        )):null
    }
    </Menu>
  );
});